export default "__VITE_ASSET__CMQCVt0X__"